import { Audience } from '@tmh-website/shared/const';

/**
 * Determines whether the passed-in `subject` is a valid `Audience`.
 *
 * @param subject - The value to check.
 *
 * @typeGuard
 */
export const isAudience = (subject: unknown): subject is Audience => {
  return Object.values(Audience).includes(subject as Audience);
};
